import React, { FC, useState } from 'react';

import { EvComboboxOption, EvSelectNew } from '@evinced-private/ui-common';

import { SCOPE_ACTIONS } from '../../../../types/scope/ScopeActions';
import { IScopeRuleRowProps } from '../scope-rules-list/ScopeRulesList.types';

import {
	ACTION_LABEL,
	ACTION_PLACEHOLDER,
	ISSUE_TYPE_VALUE_LABEL,
	ISSUE_TYPE_VALUE_PLACEHOLDER,
	ISSUE_TYPES_ACTIONS,
	MAX_DISPLAYED_ITEMS,
	REMOVE_ISSUE_BUTTON_TITLE
} from './IssueTypesRuleRow.constants';
import { ScopeRuleRow } from './ScopeRuleRow';

export const IssueTypesRuleRow: FC<IScopeRuleRowProps> = ({
	rule,
	issueTypesList,
	onRemove,
	onRuleChange
}) => {
	const [selectedAction, setSelectedAction] = useState<EvComboboxOption>(
		ISSUE_TYPES_ACTIONS.find((action) => action.value === rule?.scopeAction)
	);

	const [selectedIssueTypes, setSelectedIssueTypes] = useState<EvComboboxOption[]>(() => {
		if (rule?.issueTypes?.length) {
			return rule.issueTypes.map((issueType: string) => {
				return { label: issueType, value: issueType };
			});
		}
		return [];
	});

	return (
		<ScopeRuleRow
			removeButtonTitle={REMOVE_ISSUE_BUTTON_TITLE}
			onRemove={onRemove}
			actionControl={
				<EvSelectNew
					id="issue-type-rule-select"
					options={ISSUE_TYPES_ACTIONS}
					selectedValue={[selectedAction]}
					onSelectChange={(selected) => {
						setSelectedAction(selected[0]);
						onRuleChange?.({ ...rule, scopeAction: selected[0].value as SCOPE_ACTIONS });
					}}
					placeholder={ACTION_PLACEHOLDER}
					label={ACTION_LABEL}
				/>
			}
			valueControl={
				<EvSelectNew
					id="issue-types-select-list"
					options={issueTypesList}
					selectedValue={selectedIssueTypes}
					onSelectChange={(selected) => {
						setSelectedIssueTypes(selected);
						onRuleChange?.({ ...rule, issueTypes: selected.map((issue) => issue.label) });
					}}
					placeholder={ISSUE_TYPE_VALUE_PLACEHOLDER}
					label={ISSUE_TYPE_VALUE_LABEL}
					isMultiple
					maxDisplayedItems={MAX_DISPLAYED_ITEMS}
				/>
			}
		/>
	);
};
